<template>
	<div id="tools">
		<h1></h1>
		<b-row>
			<b-col md=3>
			</b-col>
			<b-col md=6>
				<transit-calculator></transit-calculator>
			</b-col>
			<b-col md=3>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import transitCalculator from './transitCalculator'
export default {
    components: {
        'transit-calculator': transitCalculator
    }
}
</script>
